import cn from 'classnames';

interface ApplicationIconProps {
  className?: string;
  url: string;
}

const ApplicationIcon = ({ className, url }: ApplicationIconProps) => {
  return (
    <div className={cn('w-6 h-6 relative', className)}>
      <div
        className="w-6 h-6 left-0 top-0 absolute rounded-md bg-gray-200 bg-center bg-no-repeat bg-cover"
        style={{
          backgroundImage: `url(${url})`,
        }}
      />
    </div>
  );
};

export default ApplicationIcon;
